import { useEffect, useSyncExternalStore } from 'react';
import { installStore, startInstallCapture } from '../utils/installApp';
export default function useInstallApp() {
  useEffect(() => { startInstallCapture(); }, []);
  return useSyncExternalStore(installStore.subscribe, installStore.getSnapshot, installStore.getServerSnapshot);
}
